const cityByProvince = {
  'Eastern Cape': [
    'Port Elizabeth (Gqeberha)',
    'East London',
    'Mthatha',
    'Grahamstown (Makhanda)',
    'Queenstown',
    'King William\'s Town',
    'Uitenhage',
    'Other'
  ],
  'Free State': [
    'Bloemfontein',
    'Welkom',
    'Bethlehem',
    'Kroonstad',
    'Sasolburg',
    'Parys',
    'Other'
  ],
  'Gauteng': [
    'Johannesburg',
    'Pretoria',
    'Centurion',
    'Sandton',
    'Soweto',
    'Benoni',
    'Boksburg',
    'Brakpan',
    'Springs',
    'Germiston',
    'Alberton',
    'Midrand',
    'Randburg',
    'Roodepoort',
    'Kempton Park',
    'Other'
  ],
  'KwaZulu-Natal': [
    'Durban',
    'Pietermaritzburg',
    'Newcastle',
    'Richards Bay',
    'Port Shepstone',
    'Ladysmith',
    'Empangeni',
    'Other'
  ],
  'Limpopo': [
    'Polokwane',
    'Tzaneen',
    'Mokopane',
    'Thohoyandou',
    'Louis Trichardt',
    'Musina',
    'Other'
  ],
  'Mpumalanga': [
    'Nelspruit (Mbombela)',
    'Witbank (eMalahleni)',
    'Secunda',
    'Middelburg',
    'Ermelo',
    'Barberton',
    'Other'
  ],
  'North West': [
    'Rustenburg',
    'Klerksdorp',
    'Potchefstroom',
    'Mahikeng',
    'Brits',
    'Other'
  ],
  'Northern Cape': [
    'Kimberley',
    'Upington',
    'Springbok',
    'De Aar',
    'Kuruman',
    'Other'
  ],
  'Western Cape': [
    'Cape Town',
    'Stellenbosch',
    'Paarl',
    'Worcester',
    'George',
    'Mossel Bay',
    'Hermanus',
    'Other'
  ]
};

export { cityByProvince }; 